import { ICategoryMenuRepository } from '@modules/header/application/ports/categoryMenu.repository.port';
import { GetCategoryMenuQueryDocument } from '@modules/libs/graphql/generated/graphql';
import { gqlQuery } from '@modules/libs/graphql/gql-config';
import { CategoryMenuEntityMapper, ICategoryMenuResponse } from '../../outbound/ports/categoryMenu.mapper';
export class CategoryMenuRepositoryImpl implements ICategoryMenuRepository {
  async getCategoryMenu(): ICategoryMenuRepository.getCategoryOutput {
    try {
      const {
        data
      } = await gqlQuery({
        query: GetCategoryMenuQueryDocument
      });
      return CategoryMenuEntityMapper.toDomain(data as ICategoryMenuResponse);
    } catch (error: any) {
      console.error('Error CategoryMenuRepositoryImpl.getCategoryMenu', error);
      throw error;
    }
  }
}